import React, { useState } from 'react';
import { Box, Typography, Collapse } from '@mui/material';
import { ButtonV2, IconButtonV2 } from 'components/common/ui';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import styles from './instaTaskSection.styles';

/**
 * @param {string} title - The section title/header text
 * @param {ReactNode} icon - Optional icon to display next to the title (triggers white background)
 * @param {ReactNode} children - The collapsible content
 * @param {boolean} defaultExpanded - Whether the section starts expanded (default: true)
 * @param {Object} primaryAction - Optional primary action button with label and onClick
 * @param {Object} secondaryAction - Optional secondary action button with label and onClick
 * @param {Function} onToggle - Optional callback when section is toggled (receives expanded state)
 */

const InstaTaskSection = ({
  title,
  icon,
  children,
  defaultExpanded = true,
  primaryAction,
  secondaryAction,
  onToggle,
  hideActions = false,
}) => {
  const [expanded, setExpanded] = useState(defaultExpanded);

  const handleToggle = () => {
    const newExpanded = !expanded;
    setExpanded(newExpanded);
    if (onToggle) {
      onToggle(newExpanded);
    }
  };

  return (
    <Box sx={styles.container}>
      <Box sx={styles.sectionHeader} onClick={handleToggle}>
        <Box sx={styles.titleContainer}>
          {icon && <Box sx={styles.iconContainer}>{icon}</Box>}
          <Typography variant="h6" sx={styles.sectionTitle}>
            {title}
          </Typography>
        </Box>

        <Box sx={styles.actionsContainer}>
          {!hideActions && primaryAction && (
            <ButtonV2
              variant="contained"
              size="small"
              onClick={(e) => primaryAction.onClick(e)}
              sx={styles.primaryButton}
            >
              {primaryAction.label}
            </ButtonV2>
          )}
          {secondaryAction && (
            <ButtonV2
              variant="outlined"
              size="small"
              onClick={(e) => secondaryAction.onClick(e)}
              sx={styles.secondaryButton}
            >
              {secondaryAction.label}
            </ButtonV2>
          )}
          <IconButtonV2 variant="text" size="small" sx={styles.chevronButton}>
            {expanded ? <ExpandLessIcon /> : <ExpandMoreIcon />}
          </IconButtonV2>
        </Box>
      </Box>

      <Collapse in={expanded}>
        <Box sx={styles.contentContainer}>{children}</Box>
      </Collapse>
    </Box>
  );
};

export default InstaTaskSection;
